"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JackpotService = void 0;
const types_1 = require("../models/games/types");
const api_1 = require("./api");
const games_service_1 = require("./games-service");
const PATH = '/jackpot/api/v1';
class JackpotService {
    static async getWinningNumbers(gameId, startDate, endDate, tickets, latestDraw) {
        const url = `${PATH}/winning-results?latestDraw=${latestDraw}`;
        try {
            const response = await api_1.API.post({
                url,
                body: {
                    gameId,
                    startDate,
                    endDate,
                    tickets
                }
            });
            return response;
        }
        catch (error) {
            return error;
        }
    }
    static async getLatestJackpotResultByStatus(gameId, status) {
        try {
            return await api_1.API.get({
                url: `${PATH}/jackpot-results?jackpotStatus=${types_1.IJackpotStatus[status]}&gameId=${gameId}`
            });
        }
        catch (e) {
            throw e;
        }
    }
    static async getJackpotResultsForTheGame(gameId, status, page, size) {
        const url = `${PATH}/jackpot-results?gameId=${gameId}&jackpotStatus=${types_1.IJackpotStatus[status]}&page=${page || 0}&size=${size || 9999}&sort=externalId,drawDate,desc`;
        try {
            const response = await api_1.API.get({ url });
            const last = Math.ceil((response.totalElements - 1) / response.size) <= response.number + 1;
            const totalPages = Math.ceil((response.totalElements - 1) / response.size);
            const recentDraw = response.content && response.content.length > 0 ? response.content[0] : {};
            return {
                recentDraw,
                content: response.content,
                page: {
                    first: response.first,
                    last,
                    totalElements: response.totalElements,
                    totalPages,
                    number: response.number
                }
            };
        }
        catch (error) {
            throw error;
        }
    }
    static async getJackpotResultsForGameByFilter(gameId, status, drawId, limit) {
        const url = `${PATH}/jackpot-results/game/${gameId}?jackpotStatus=${types_1.IJackpotStatus[status]}&drawId=${drawId}&limit=${limit}`;
        try {
            return await api_1.API.get({ url });
        }
        catch (error) {
            throw error;
        }
    }
    static async getJackpotGames() {
        const url = `${PATH}/jackpot-results/games`;
        try {
            return (await api_1.API.get({ url }));
        }
        catch (error) {
            throw error;
        }
    }
    static async getWinningNumberFilePaths(gameId) {
        try {
            const response = await api_1.API.get({
                url: `${PATH}/winning-number-results/file-path/${gameId}`
            });
            return response;
        }
        catch (error) {
            throw error;
        }
    }
    static async getPayableJackpotResults(gameId) {
        const url = `${PATH}/jackpot-results?jackpotStatus=PAYABLE&gameId=${gameId}`;
        try {
            return await api_1.API.get({ url });
        }
        catch (error) {
            throw error;
        }
    }
    static async getLatestJackpotResultForKeno(id) {
        try {
            const response = await api_1.API.get({
                url: `${PATH}/jackpot-results/games/${id}`
            });
            if (response) {
                return {
                    jackpotResult: response,
                    resultData: response.resultData,
                    gameNumbers: games_service_1.GamesService.convertResultDataForKeno(response.resultData)
                };
            }
            else {
                return {
                    jackpotResult: null,
                    resultData: [],
                    gameNumbers: []
                };
            }
        }
        catch (error) {
            throw error;
        }
    }
    static async getJackpotResultForKenoAndDraw(gameId, drawId) {
        try {
            const response = await api_1.API.get({
                url: `${PATH}/jackpot-results/games/${gameId}/${drawId}`
            });
            if (response) {
                return {
                    jackpotResult: response,
                    resultData: response.resultData,
                    gameNumbers: games_service_1.GamesService.convertResultDataForKeno(response.resultData),
                    currentDraw: drawId
                };
            }
            else {
                return {
                    jackpotResult: null,
                    resultData: [],
                    gameNumbers: [],
                    currentDraw: drawId
                };
            }
        }
        catch (error) {
            throw error;
        }
    }
    static async getSingleDrawPayout(gameId, drawId, playerSpots, ticketCost) {
        var _a, _b;
        try {
            const response = await api_1.API.post({
                url: `${PATH}/jackpot-results/${gameId}/${drawId}`,
                body: {
                    ticketCost,
                    playerSpots: playerSpots.join(',')
                }
            });
            return Object.assign(Object.assign({}, response), { resultData: (_a = response === null || response === void 0 ? void 0 : response.jackpotResult) === null || _a === void 0 ? void 0 : _a.resultData, gameNumbers: games_service_1.GamesService.convertResultDataForKeno((_b = response === null || response === void 0 ? void 0 : response.jackpotResult) === null || _b === void 0 ? void 0 : _b.resultData) });
        }
        catch (error) {
            throw error;
        }
    }
    static async getMultipleDrawsPayout(gameId, drawIds, playerSpots, ticketCost) {
        try {
            const response = await api_1.API.post({
                url: `${PATH}/jackpot-results/${gameId}`,
                body: {
                    ticketCost,
                    playerSpots: playerSpots.join(','),
                    drawNumbers: drawIds
                }
            });
            let tempResponse = [];
            if (response) {
                tempResponse = response.map((item) => {
                    if (item.jackpotResult) {
                        item.gameNumbers = games_service_1.GamesService.convertResultDataForKeno(item.jackpotResult.resultData);
                        item.resultData = item.jackpotResult.resultData;
                    }
                    return item;
                });
            }
            return tempResponse;
        }
        catch (error) {
            throw error;
        }
    }
    static async getHotAndColdNumbers(gameId, numberOfDraws) {
        const url = `${PATH}/winning-number-results/hot-cold-numbers/${gameId}/${numberOfDraws}`;
        try {
            return await api_1.API.get({ url });
        }
        catch (error) {
            throw error;
        }
    }
}
exports.JackpotService = JackpotService;
//# sourceMappingURL=jackpot-service.js.map